import {
  LongTextField,
  ReferenceListField,
  useTabVisibility,
} from "ra-friendsofbabba";

import React from "react";
import { TextField } from "react-admin";
import { get } from "lodash";
import { useFormState } from "react-final-form";

const TARGET = {
  public: "company",
  private: "partner",
};
const StaffUsersField = ({ type, tab = 3, ...props }) => {
  const formState = useFormState();
  const companyTypeId = get(
    formState.values,
    `${TARGET[type]}.company_type_id`
  );
  const visible = useTabVisibility(tab);
  if (!visible) {
    return null;
  }
  return (
    <ReferenceListField
      {...props}
      tab={3}
      perPage={5}
      label={`resources.research-projects.fields.${companyTypeId}.${props.source}`}
      reference="research-project-staff-users"
      target="research_project_id"
      sort={{ field: "id", order: "ASC" }}
      filter={{ type }}
      additionalData={{ type }}
      create={!props.disabled}
      modify={!props.disabled}
      remove={!props.disabled}
    >
      <LongTextField source="nominative" variant="body2" minWidth={100} />
      <TextField source="staff_user_role_name" />
      <LongTextField
        source="relevance"
        label="resources.research-project-staff-users.fields.relevance.short"
        maxRows={3}
        variant="body2"
      />
    </ReferenceListField>
  );
};

export default StaffUsersField;
